import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-feature-section',
  templateUrl: './feature-section.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./feature-section.component.scss']
})
export class FeatureSectionComponent implements OnInit {

  sectionInputTwoCards: any = [
    {
      description:
        'National Cloud - Class (C)',
      imagePath: '../../../../assets/svg/cloud.svg',
    },
    {
      description:
        'On-prem Hosting Option',
        imagePath: '../../../../assets/svg/building.svg',
    },
    {
      description: 'Sync with Active Directory',
      imagePath: '../../../../assets/svg/arrowrotateleft.svg',
    },
    {
      description:
        'Integrate with 3rd Party APIs',
        imagePath: '../../../../assets/svg/arrangehorizontal.svg',
    },
    {
      description:
        'Arabic and English Interfaces',
        imagePath: '../../../../assets/svg/languagesquare.svg',
    }
  ];

  constructor() { }


  ngOnInit(): void {

  }

}

